import { pushApi } from "../api";

export async function subscribeToPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return null;
  }

  // if already subscribed, return existing subscription
  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    return subscription.toJSON();
  }

  if (Notification.permission === 'denied') {
    console.log('Push permission denied');
    // TODO: show a popup explaining benefits
    alert('You have blocked push notifications. To receive updates about your trip, please enable notifications in your browser settings.');
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    console.log('Push permission not granted');
    return null;
  }

  let vapidPublicKey;
  try {
    vapidPublicKey = await pushApi.getVapidPublicKey();
  } catch (error) {
    console.error('Error getting VAPID public key:', error);
    return null;
  }

  try {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
    });

    // .keys is hidden because stored internally as CryptoObject
    // use toJSON so that .keys is accessible
    const subscriptionWithKeys = subscription.toJSON();

    // unpack and send minimal payload to backend (matches serializer)
    const payload = {
      endpoint: subscriptionWithKeys.endpoint,
      // expiration_time: subscriptionWithKeys.expirationTime,
      p256dh: subscriptionWithKeys.keys.p256dh,
      auth: subscriptionWithKeys.keys.auth,
      userAgent: getSanitizedUserAgent(),
    };

    await pushApi.subscribe(payload);

    return subscriptionWithKeys;
  } catch (error) {
    console.error('Error subscribing to push:', error);
    return null;
  }
}

export async function unsubscribeFromPush() {
  const registration = await navigator.serviceWorker.ready;
  const sub = await registration.pushManager.getSubscription();
  if (!sub) {
    return;
  }

  try {
    await pushApi.unsubscribe(sub.endpoint);
    await sub.unsubscribe();
  } catch (error) {
    console.error('Error unsubscribing from push:', error);
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// sanitize user agent to avoid PII (personally identifiable information)
function getSanitizedUserAgent() {
  const ua = navigator.userAgent;
  // Simple regex to extract browser name and version
  const match = ua.match(/(Firefox|Chrome|Safari|Edg|Opera)[\/\s](\d+\.\d+)/i);
  if (match) {
    return `${match[1]}/${match[2]}`;
  }
  return "Unknown";
}